module.exports = __webpack_public_path__ + "static/media/corona.d7265326.png";